/* eslint-disable */
const // ENV
  BASE_URL = (exports.BASE_URL = process.env.REACT_APP_BASE_URL),
  BASE_URL_V1 = (exports.BASE_URL_V1 = process.env.REACT_APP_BASE_URL_V1),
  BASE_URL_V2 = (exports.BASE_URL_V2 = process.env.REACT_APP_BASE_URL_V2),
  BASE_URL_VALIDATE_RFC = (exports.BASE_URL_VALIDATE_RFC = process.env.REACT_APP_BASE_URL_VALIDATE_RFC),
  BASE_URL_SAP = (exports.BASE_URL_SAP = process.env.REACT_APP_SAP_BO_BASE_URL);

// Auth
(LOGIN = exports.LOGIN = `${BASE_URL_V2}/auth`),
  (CHECK_ACCESS = exports.CHECK_ACCESS = `${BASE_URL_V1}/auth/check-access`),
  // One time sign in/up
  (OT_SIGNIN = exports.OT_SIGNIN = `${BASE_URL_V1}/ot_signin`),
  (OT_SIGNUP = exports.OT_SIGNUP = `${BASE_URL_V1}/ot_signup`),
  // Payments
  (PAYMENT_BASE = exports.PAYMENT_BASE = `${BASE_URL_V1}/payment`),
  (PAYMENT_SINGLE = exports.PAYMENT_SINGLE = `${BASE_URL_V1}/payment/:uuid`),
  (PAYMENT_REP = exports.PAYMENT_REP = `${BASE_URL_V1}/payment/:uuid/rep`),
  (PAYMENT_REP_CANCEL = exports.PAYMENT_REP_CANCEL = `${BASE_URL_V1}/payment/:uuid/cancel`),
  (PAYMENT_CANCEL_NOTIFY = exports.PAYMENT_CANCEL_NOTIFY = `${BASE_URL_V1}/payment/:uuid/cancel/notify`),
  (PAYMENT_NOTES = exports.PAYMENT_NOTES = `${BASE_URL_V1}/payment/:uuid/note`),
  (PAYMENT_REMINDER = exports.PAYMENT_REMINDER = `${BASE_URL_V1}/payment/:uuid/collection`),
  // Invoice
  (INVOICE_BASE = exports.INVOICE_BASE = `${BASE_URL_V1}/invoice`),
  (INVOICE_CFDI = exports.INVOICE_CFDI = `${BASE_URL_V1}/invoice/cfdi`),
  (INVOICE_INVOICE = exports.INVOICE_INVOICE = `${BASE_URL_V1}/invoice/invoice`),
  (INVOICE_IMPORT_XML = exports.INVOICE_IMPORT_XML = `${BASE_URL_V1}/invoice/import/xml`),
  (INVOICE_IMPORT_SAT = exports.INVOICE_IMPORT_SAT = `${BASE_URL_V1}/invoice/import/sat`),
  (INVOICE_SINGLE = exports.INVOICE_SINGLE = `${BASE_URL_V1}/invoice/:uuid`),
  (INVOICE_UPDATE = exports.INVOICE_UPDATE = `${BASE_URL_V1}/invoice/:uuid/sale-note`),
  (INVOICE_PAYED = exports.INVOICE_PAYED = `${BASE_URL_V1}/invoice/payment`),
  (INVOICE_ITEMS = exports.INVOICE_ITEMS = `${BASE_URL_V1}/invoice/:uuid/item`),
  (INVOICE_FILES = exports.INVOICE_FILES = `${BASE_URL_V1}/invoice/:uuid/attachment`),
  (INVOICE_NOTE = exports.INVOICE_NOTE = `${BASE_URL_V1}/invoice/quick_collection`),
  (INVOICE_EXPORT = exports.INVOICE_EXPORT = `${BASE_URL_V1}/download/invoice`),
  (INVOICE_EMIT_CFDI = exports.INVOICE_EMIT_CFDI = `${BASE_URL_V1}/invoice/:uuid/cfdi`),
  (INVOICE_NOTE_IMPORT = exports.INVOICE_NOTE_IMPORT = `${BASE_URL_V1}/import/invoice`),
  (INVOICE_CANCEL_CFDI = exports.INVOICE_CANCEL_CFDI = `${BASE_URL_V1}/invoice/:uuid/cancel`),
  (INVOICE_CANCEL_NOTIFY = exports.INVOICE_CANCEL_NOTIFY = `${BASE_URL_V1}/invoice/:uuid/cancel/notify`),
  (SALE_NOTE_CANCEL = exports.SALE_NOTE_CANCEL = `${BASE_URL_V1}/invoice/:uuid/sale-note/cancel`),
  (SALE_NOTE_RESTORE = exports.SALE_NOTE_RESTORE = `${BASE_URL_V1}/invoice/:uuid/sale-note/restore`),
  (INVOICE_CREDIT_NOTE = exports.INVOICE_CREDIT_NOTE = `${BASE_URL_V1}/invoice/:uuid/credit_note`),
  (INVOICE_CONTPAQI = exports.INVOICE_CONTPAQI = `${BASE_URL_V1}/invoice/:uuid/contpaqi`),
  (INVOICE_NOTES = exports.INVOICE_NOTES = `${BASE_URL_V1}/invoice/:uuid/note`),
  (INVOICE_UNPAID = exports.INVOICE_UNPAID = `${BASE_URL_V1}/download/invoice_unpaid`),
  // Reminders
  (REMINDERS_BASE = exports.REMINDERS_BASE = `${BASE_URL_V1}/team/collection`),
  // Customer
  (CUSTOMER_BASE = exports.CUSTOMER_BASE = `${BASE_URL_V1}/customer`),
  (CUSTOMER_DEBT = exports.CUSTOMER_DEBT = `${BASE_URL_V1}/customer?due=`), //true`,
  (CUSTOMER_SINGLE = exports.CUSTOMER_SINGLE = `${BASE_URL_V1}/customer/:uuid`),
  (CUSTOMER_INVOICES = exports.CUSTOMER_INVOICES = `${BASE_URL_V1}/customer/:uuid/invoice`),
  (CUSTOMER_PAYMENTS = exports.CUSTOMER_PAYMENTS = `${BASE_URL_V1}/customer/:uuid/payment`),
  (CUSTOMER_CONTRACTS = exports.CUSTOMER_CONTRACTS = `${BASE_URL_V1}/customer/:uuid/contract`),
  (ACCOUNT_STATEMENT = exports.ACCOUNT_STATEMENT = `${BASE_URL_V1}/account_statement/email`),
  (ACCOUNT_STATEMENT_SMS = exports.ACCOUNT_STATEMENT_SMS = `${BASE_URL_V1}/account_statement/sms`),
  (ACCOUNT_STATEMENT_WP = exports.ACCOUNT_STATEMENT_WP = `${BASE_URL_V1}/account_statement/whatsapp`),
  (CUSTOMER_EXPORT = exports.CUSTOMER_EXPORT = `${BASE_URL_V1}/download/customer`),
  (CUSTOMER_IMPORT = exports.CUSTOMER_IMPORT = `${BASE_URL_V1}/import/customer`),
  (CUSTOMER_ACTIVITY = exports.CUSTOMER_ACTIVITY = `${BASE_URL_V1}/customer/:uuid/activities`),
  (CUSTOMER_REPORT = exports.CUSTOMER_REPORT = `${BASE_URL_V1}/customer/:uuid/report`),
  (CUSTOMER_NOTES = exports.CUSTOMER_NOTES = `${BASE_URL_V1}/customer/:uuid/recent_notes`),
  (CUSTOMER_REMINDERS = exports.CUSTOMER_REMINDERS = `${BASE_URL_V1}/customer/:uuid/sent_reminders`),
  (CUSTOMER_TAXES = exports.CUSTOMER_TAXES = `${BASE_URL_V1}/customer/:uuid/tax-data`),
  (CUSTOMER_VALIDATION_RFC = exports.CUSTOMER_VALIDATION_RFC = `${BASE_URL_VALIDATE_RFC}/validate-rfc`),
  (CUSTOMER_CURRENCY = exports.CUSTOMER_CURRENCY = `${BASE_URL_V1}/customer/:uuid/currencies`),
  (CUSTOMER_OYSTER_CLABE_STATUS = exports.CUSTOMER_OYSTER_CLABE_STATUS = `${BASE_URL_V1}/customer/:uuid/oyster-clabe-status`),
  (CLIENT_CURRENCY = exports.CLIENT_CURRENCY = `${BASE_URL_V1}/client/:uuid/currencies`),
  (ZIP_DOWNLOAD = exports.ZIP_DOWNLOAD = `${BASE_URL_V1}/client/zip-download`),
  // Settings
  (COUNTRY_REGION = exports.COUNTRY_REGION = `${BASE_URL_V1}/catalog/country/:region/district`),
  (PROFILE = exports.PROFILE = `${BASE_URL_V1}/settings/profile`),
  (TEAM = exports.TEAM = `${BASE_URL_V1}/settings/team`),
  (USER_SETTINGS = exports.USER_SETTINGS = `${BASE_URL_V1}/settings`),
  // Subscription
  (CREATE_SUSCRIPTION = exports.CREATE_SUSCRIPTION = `${BASE_URL_V1}/team/subscription`),
  (VALIDATE_COUPON = exports.VALIDATE_COUPON = `${BASE_URL_V1}/team/subscription/coupons`),
  (BUY_PACKAGES = exports.BUY_PACKAGES = `${BASE_URL_V1}/team/package/:name`),
  (BUY_CONSUMABLES = exports.BUY_CONSUMABLES = `${BASE_URL_V2}/subscriptions/consumables/buy-by-product-code`),
  // Backend
  (RESET_FREEMIUM = exports.RESET_FREEMIUM = `${BASE_URL_V1}/settings/freemium`),
  (RESET_COUNTERS = exports.RESET_COUNTERS = `${BASE_URL_V1}/settings/counters`),
  (BACK_TO_FREE = exports.BACK_TO_FREE = `${BASE_URL_V1}/team/subscription`),
  (REMOVE_PAYMENT_METHOD = exports.REMOVE_PAYMENT_METHOD = `${BASE_URL_V1}/team/payment_method`),
  // DE DUPE
  (CREATE_PAYMENT_METHOD = exports.CREATE_PAYMENT_METHOD = `${BASE_URL_V1}/team/payment_method`),
  (SUBSCRIPTION_PAYMENT = exports.SUBSCRIPTION_PAYMENT = `${BASE_URL_V1}/team/payment_method`),
  (SUBSCRIPTION_ACTIVE = exports.SUBSCRIPTION_ACTIVE = `${BASE_URL_V1}/team/subscription?enabled=true`),
  (SUBSCRIPTION_TRANSACTIONS = exports.SUBSCRIPTION_TRANSACTIONS = `${BASE_URL_V1}/team/subscription/transaction?page=1`),
  (SUBSCRIPTION = exports.SUBSCRIPTION = `${BASE_URL_V1}/team/subscription`),
  // SUBSCRIPTION V2
  (SUBSCRIPTION_V2 = exports.SUBSCRIPTION_V2 = `${BASE_URL_V2}/subscriptions`),
  (SUBSCRIPTION_CONTACT_SUPPORT_V2 = exports.SUBSCRIPTION_CONTACT_SUPPORT_V2 = `${BASE_URL_V2}/subscriptions/support`),
  (SUBSCRIPTION_ACTIVE_V2 = exports.SUBSCRIPTION_ACTIVE_V2 = `${BASE_URL_V2}/subscriptions/current`),
  (SUBSCRIPTION_PURCHASES_STATS = exports.SUBSCRIPTION_PURCHASES_STATS = `${BASE_URL_V2}/subscriptions/purchases/stats`);

// Stats
(TEAM_STATS = exports.TEAM_STATS = `${BASE_URL_V1}/team/stats`),
  (PACKAGE_STATS = exports.PACKAGE_STATS = `${BASE_URL_V1}/team/package/stats`),
  // Emails
  (EMAIL_SETTINGS_BASE = exports.EMAIL_SETTINGS_BASE = `${BASE_URL_V1}/settings/template`),
  (EMAIL_SETTINGS_BY_ID = exports.EMAIL_SETTINGS_BY_ID = `${BASE_URL_V1}/settings/template?type=:templateId`),
  // Sms
  (SMS_SETTINGS_BASE = exports.SMS_SETTINGS_BASE = `${BASE_URL_V1}/settings/template/sms`),
  (WP_SETTINGS_BASE = exports.WP_SETTINGS_BASE = `${BASE_URL_V1}/settings/template/whatsapp`),
  (SMS_SETTINGS_BY_ID = exports.SMS_SETTINGS_BY_ID = `${BASE_URL_V1}/settings/template/sms?type=:templateId`),
  (WHATSAPP_SETTINGS_BY_ID = exports.WHATSAPP_SETTINGS_BY_ID = `${BASE_URL_V1}/settings/template/whatsapp?type=:templateId`),
  // Collection
  (COLLECTION_BASE = exports.COLLECTION_BASE = `${BASE_URL_V1}/settings/collection`),
  (COLLECTION_SINGLE = exports.COLLECTION_SINGLE = `${BASE_URL_V1}/settings/collection/:uuid`),
  (INVOICE_SINGLE_COLLECTION = exports.INVOICE_SINGLE_COLLECTION = `${BASE_URL_V1}/invoice/:uuid/collection`),
  (INVOICE_COLLECTION = exports.INVOICE_COLLECTION = `${BASE_URL_V1}/invoice/:uuid/collection`),
  (INVOICE_SINGLE_COLLECTION_SMS = exports.INVOICE_SINGLE_COLLECTION_SMS = `${BASE_URL_V1}/invoice/:uuid/collection/sms`),
  (INVOICE_SINGLE_COLLECTION_WHATSAPP = exports.INVOICE_SINGLE_COLLECTION_WHATSAPP = `${BASE_URL_V1}/invoice/:uuid/collection/whatsapp`),
  // Integrations
  (INTEGRATION = exports.INTEGRATION = `${BASE_URL_V1}/settings/integration`),
  (VALIDATION_RFC = exports.VALIDATION_RFC = `${BASE_URL_V1}/settings/integration/rfc`),
  (SAT_INTEGRATION = exports.SAT_INTEGRATION = `${BASE_URL_V1}/settings/integration/1`),
  (DOWNLOAD_INVOICES = exports.DOWNLOAD_INVOICES = `${BASE_URL_V1}/settings/integration/7`),
  (SAT_CERTIFICATES = exports.SAT_CERTIFICATES = `${BASE_URL_V1}/settings/integration/certs`),
  (SAT_INTEGRATION_ERRORS = exports.SAT_INTEGRATION_ERRORS = `${BASE_URL_V1}/team/action`),
  (PAYMENT_INSTRUCTIONS_INT = exports.PAYMENT_INSTRUCTIONS_INT = `${BASE_URL_V1}/settings/integration/2`),
  (SPEI_INTEGRATION = exports.SPEI_INTEGRATION = `${BASE_URL_V1}/settings/integration/3`),
  (SYNC_SAT = exports.SYNC_SAT = `${BASE_URL_V1}/invoice/import/sat`),
  (STRIPE_INTEGRATION = exports.STRIPE_INTEGRATION = `${BASE_URL_V1}/settings/integration/4`),
  (CONEKTA_INTEGRATION = exports.CONEKTA_INTEGRATION = `${BASE_URL_V1}/settings/integration/5`),
  (OXXO_INTEGRATION = exports.OXXO_INTEGRATION = `${BASE_URL_V1}/settings/integration/6`),
  (CONTPAQI_INTEGRATION = exports.CONTPAQI_INTEGRATION = `${BASE_URL_V1}/settings/integration/8`),
  (CONTPAQI_INTEGRATION_V2 = exports.CONTPAQI_INTEGRATION_V2 = `${BASE_URL_V1}/settings/integration_v2/8`),
  (RELATION_CONCEPTS = exports.RELATION_CONCEPTS = `${BASE_URL_V1}/payment/contpaqi/relation-concepts`),
  (SAVE_RELATION_CONCEPTS = exports.SAVE_RELATION_CONCEPTS = `${BASE_URL_V1}/payment/contpaqi/relation-concepts`),
  (SYNC_CONTPAQI = exports.SYNC_CONTPAQI = `${BASE_URL_V1}/invoice/sync/contpaqi`),
  (SPEI_ONBOARDING = exports.SPEI_ONBOARDING = `${BASE_URL_V1}/settings/integration/spei`),
  (FISERV_INTEGRATION = exports.FISERV_INTEGRATION = `${BASE_URL_V2}/integrations/payments/fiserv`),
  (INTEREST_INTEGRATION = exports.INTEREST_INTEGRATION = `${BASE_URL_V2}/interests`),
  (SAP_BUSINESS_ONE = exports.SAP_BUSINESS_ONE = `${BASE_URL_V2}/integrations/accountants/sap`),
  (EXTERNAL_SAP_URL_ACCOUNTS = exports.EXTERNAL_SAP_URL_ACCOUNTS = `${BASE_URL_SAP}/cuentas/list-cuentas/`),
  (OYSTER_INTEGRATION = exports.OYSTER_INTEGRATION = `${BASE_URL_V2}/integrations/payments/spei`),
  (NEW_FISERV_INTEGRATION = exports.NEW_FISERV_INTEGRATION = `${BASE_URL_V2}/integrations/payments/fiserv/direct-sale`),
  // Reports
  (INVOICE_SUMARY = exports.INVOICE_SUMARY = `${BASE_URL_V1}/report/invoice_collection?start_date=:startDate&end_date=:endDate`),
  (CUSTOMER_OVERDUE = exports.CUSTOMER_OVERDUE = `${BASE_URL_V1}/report/customer_overdue`),
  (COLLECTION_OVERVIEW = exports.COLLECTION_OVERVIEW = `${BASE_URL_V1}/report/invoice_collection_overview`),
  (SALES_REPORT = exports.SALES_REPORT = `${BASE_URL_V1}/report/sales/period?year=:year&month=:month`),
  // Account
  (CREATE_ACCOUNT = exports.CREATE_ACCOUNT = `${BASE_URL_V1}/account`),
  (CREATE_USER = exports.CREATE_USER = `${BASE_URL_V1}/account/user`),
  (UPDATE_USER = exports.UPDATE_USER = `${BASE_URL_V1}/account/user/:id`),
  (CREATE_USER_INVITATION = exports.CREATE_USER_INVITATION = `${BASE_URL_V1}/account/invitations`),
  (UPDATE_USER_INVITATION = exports.UPDATE_USER_INVITATION = `${BASE_URL_V1}/account/invitation/:uuid/permissions`),
  (UPDATE_USER_DATA = exports.UPDATE_USER_DATA = `${BASE_URL_V1}/account/user/:uuid/profile`),
  (REQUEST_OTP = exports.REQUEST_OTP = `${BASE_URL_V1}/account/generateOTP`),
  (CONFIRM_OTP = exports.CONFIRM_OTP = `${BASE_URL_V1}/account/confirmOTP`),
  (GET_ACCOUNT = exports.GET_ACCOUNT = `${BASE_URL_V1}/account/me`),
  (VERIFY_ACCOUNT = exports.VERIFY_ACCOUNT = `${BASE_URL_V1}/account/verification`),
  (EMAIL_VERIFY_ACCOUNT = exports.EMAIL_VERIFY_ACCOUNT = `${BASE_URL_V1}/account/me/verification`),
  (CHANGE_PASSWORD = exports.CHANGE_PASSWORD = `${BASE_URL_V1}/account/me/password/change`),
  (SEND_EMAIL_RECOVER_PASSWORD = exports.SEND_EMAIL_RECOVER_PASSWORD = `${BASE_URL_V1}/account/password/recovery`),
  (RECOVER_PASSWORD_VERYFY_TOKEN = exports.RECOVER_PASSWORD_VERYFY_TOKEN = `${BASE_URL_V1}/account/password/verify?token=`),
  (RESTORE_PASSWORD = exports.RESTORE_PASSWORD = `${BASE_URL_V1}/account/password/restore`),
  (CREATE_NEW_TEAM = exports.CREATE_NEW_TEAM = `${BASE_URL_V1}/account/:uuid/team`),
  (TEAM_TOKEN = exports.TEAM_TOKEN = `${BASE_URL_V1}/account/me/team_token`),
  (TEAMS = exports.TEAMS = `${BASE_URL_V1}/account/me/team`),
  // Companies
  (AUTH_COMPANY = exports.AUTH_COMPANY = `${BASE_URL_V2}/auth/companies`),
  (GET_COMPANIES = exports.GET_COMPANIES = `${BASE_URL_V2}/companies`),
  (EDIT_COMPANY = exports.EDIT_COMPANY = `${BASE_URL_V2}/companies/:uuid`),
  (REPORT_COMPANY = exports.REPORT_COMPANY = `${BASE_URL_V2}/companies/metabase-report`),
  (REQUEST_REPORT = exports.REQUEST_REPORT = `${BASE_URL_V2}/companies/request-report`),
  (DELETE_COMPANY = exports.DELETE_COMPANY = `${BASE_URL_V2}/companies/:uuid`),
  // Invitations
  (INVITATIONS = exports.INVITATIONS = `${BASE_URL_V1}/enterprise/:uuid/invite`),
  (INVITATIONS_USERS = exports.INVITATIONS_USERS = `${BASE_URL_V1}/account/invitation`),
  (INVITATIONS_TEAMS = exports.INVITATIONS_TEAMS = `${BASE_URL_V1}/invitation/team`),
  // Users
  (USERS = exports.USERS = `${BASE_URL_V1}/account/user`),
  // Notifications
  (GET_TEAM_NOTIFICATIONS = exports.GET_TEAM_NOTIFICATIONS = `${BASE_URL_V1}/team/notification?limit=100`),
  (UPDATE_TEAM_NOTIFICATIONS = exports.UPDATE_TEAM_NOTIFICATIONS = `${BASE_URL_V1}/team/notification`),
  // Product
  (GET_ALL_PRODUCTS = exports.GET_ALL_PRODUCTS = `${BASE_URL_V1}/item?`),
  (CREATE_PRODUCT = exports.CREATE_PRODUCT = `${BASE_URL_V1}/item`),
  (EDIT_PRODUCT = exports.EDIT_PRODUCT = `${BASE_URL_V1}/item/:uuid`),
  (GET_TAXES = exports.GET_TAXES = `${BASE_URL_V1}/settings/tax?price=:itemPrice`),
  (ADD_TAX = exports.ADD_TAX = `${BASE_URL_V1}/item/:uuid/tax`),
  (DELETE_TAX = exports.DELETE_TAX = `${BASE_URL_V1}/item/:uuid/tax/:id`),
  (GET_SAT_CODES = exports.GET_SAT_CODES = 'https://search.yay.do/search/autocomplete/claveprodserv_satcodes?q='),
  // Client Portal
  (CLIENT_DETAIL = exports.CLIENT_DETAIL = `${BASE_URL_V1}/client/:uuid`),
  (CLIENT_INVOICES = exports.CLIENT_INVOICES = `${BASE_URL_V1}/client/:uuid/invoice`),
  (CLIENT_INVOICES_FROM_UUID = exports.CLIENT_INVOICES_FROM_UUID = `${BASE_URL_V1}/client/:uuid/invoices`),
  (CLIENT_CONTRACTS = exports.CLIENT_CONTRACTS = `${BASE_URL_V1}/client/:uuid/contract`),
  (CLIENT_CONTRACT_KPIS = exports.CLIENT_CONTRACT_KPIS = `${BASE_URL_V1}/client/:uuid/contract/kpis`),
  (CLIENT_PAYMENTS = exports.CLIENT_PAYMENTS = `${BASE_URL_V1}/client/:uuid/payment`),
  (CLIENT_PROVIDER = exports.CLIENT_PROVIDER = `${BASE_URL_V1}/client/:uuid/provider`),
  (CLIENT_RECURRING_PAYMENT = exports.CLIENT_RECURRING_PAYMENT = `${BASE_URL_V1}/client/:uuid/contract/recurring_payment`),
  (CLIENT_CONFIRM_DOMICILIATION = exports.CLIENT_CONFIRM_DOMICILIATION = `${BASE_URL_V1}/client/:uuid/contact/recurring_payment_request`),
  (CLIENT_RECURRING_PAYMENT_QUERY = exports.CLIENT_RECURRING_PAYMENT_QUERY = `${BASE_URL_V1}/client/:uuid/contract/recurring_payment`),
  (CLIENT_UPDATE_RECURRING_PAYMENT_QUERY = exports.CLIENT_UPDATE_RECURRING_PAYMENT_QUERY = `${BASE_URL_V1}/client/domiciliation/fiserv`),
  (CLIENT_SETTINGS = exports.CLIENT_SETTINGS = `${BASE_URL_V1}/clients/:uuid/settings`),
  (CLIENT_INVOICE_BALANCE = exports.CLIENT_INVOICE_BALANCE = `${BASE_URL_V1}/client/:uuid/invoices?q=:invoice`),
  (CLIENT_REDIRECT = exports.CLIENT_REDIRECT = `${BASE_URL}/redirect/client/:uuid`),
  (PAYMENT_INTENT = exports.PAYMENT_INTENT = `${BASE_URL_V1}/pay_intent`),
  (CLIENT_COUNTRY_REGION = exports.CLIENT_COUNTRY_REGION = `${BASE_URL_V1}/client/country/:region/district`),
  (CLIENT_TAX = exports.CLIENT_TAX = `${BASE_URL_V1}/client/:uuid/tax-data`),
  (CLIENT_TAX_DELETE = exports.CLIENT_TAX_DELETE = `${BASE_URL_V1}/client/:uuid/tax-data/:tax_uuid`),
  (CLIENT_GENERATE_CFDI = exports.CLIENT_GENERATE_CFDI = `${BASE_URL_V1}/client/:uuid/sales-notes/:id/generate-cfdi`),
  // OnBoarding
  (ONBOARDING = exports.ONBOARDING = `${BASE_URL_V1}/team/boarding`),
  // ApiKey
  (API_KEY = exports.API_KEY = `${BASE_URL_V1}/api_key`),
  // Contract
  (CREATE_CONTRACT = exports.CREATE_CONTRACT = `${BASE_URL_V1}/contract`),
  (UPDATE_CONTRACT = exports.UPDATE_CONTRACT = `${BASE_URL_V1}/contract/:uuid`),
  (CONTRACT_BASE = exports.CONTRACT_BASE = `${BASE_URL_V1}/contract`),
  (ADD_FILES_CONTRACT = exports.ADD_FILES_CONTRACT = `${BASE_URL_V1}/contract/`),
  (DELETE_FILES_CONTRACT = exports.DELETE_FILES_CONTRACT = `${BASE_URL_V1}/contract/:contractId/attachment/:attachmentId`),
  (CONTRACT_DETAIL = exports.CONTRACT_DETAIL = `${BASE_URL_V1}/contract/:uuid`),
  (CONTRACT_UPDATE = exports.CONTRACT_UPDATE = `${BASE_URL_V1}/contract/edit/:uuid`),
  (CONTRACT_EXPORT = exports.CONTRACT_EXPORT = `${BASE_URL_V1}/download/contract`),
  (CONTRACT_EXPORT_UPDATE = exports.CONTRACT_EXPORT_UPDATE = `${BASE_URL_V1}/contract/export/update`),
  (PORTAL_CONTRACT = exports.PORTAL_CONTRACT = `${BASE_URL_V1}/client/:uuid/contract/:id`),
  (CONTRACT_RECURRING_PAYMENT = exports.CONTRACT_RECURRING_PAYMENT = `${BASE_URL_V1}/contract/request_recurring_payment`),
  (CONTRACT_IMPORT = exports.CONTRACT_IMPORT = `${BASE_URL_V1}/import/contract`),
  (CONTRACT_UPDATE_IMPORT = exports.CONTRACT_UPDATE_IMPORT = `${BASE_URL_V1}/import/contract/update`),
  (CONTRACT_FRECUENCY = exports.CONTRACT_FRECUENCY = `${BASE_URL_V1}/contract/:uuid/frecuency/:id`),
  (CONTRACT_NOTES = exports.CONTRACT_NOTES = `${BASE_URL_V1}/contract/:uuid/note`),
  (CANCEL_CONTRACT = exports.CANCEL_CONTRACT = `${BASE_URL_V1}/contracts/:uuid/cancel`),
  (RECURRING_PAYMENT_CONEKTA = exports.RECURRING_PAYMENT_CONEKTA = `${BASE_URL_V1}/client/:uuid/recurring_payment_conekta`),
  (CONTRACT_MULTIPLE_CANCEL = exports.CONTRACT_MULTIPLE_CANCEL = `${BASE_URL_V1}/contract/multiple-cancel`),
  (CONTRACT_MULTIPLE_DELETE = exports.CONTRACT_MULTIPLE_DELETE = `${BASE_URL_V1}/contract/multiple-delete`),
  // Payment request
  (PAYMENT_REQUEST = exports.PAYMENT_REQUEST = `${BASE_URL_V1}/pay_request/invoice`),
  (PAYMENT_REQUEST_CHECK = exports.PAYMENT_REQUEST_CHECK = `${BASE_URL_V1}/pay_request/check`),
  (OYSTER_REFERENCE = exports.OYSTER_REFERENCE = `${BASE_URL_V1}/pay_order/spei`),
  (PAY_ORDER = exports.PAY_ORDER = `${BASE_URL_V1}/pay_order/stripe`),
  (PAY_ORDER_OXXO = exports.PAY_ORDER_OXXO = `${BASE_URL_V1}/pay_order/oxxo`),
  (PAY_ORDER_SPEI = exports.PAY_ORDER_SPEI = `${BASE_URL_V1}/pay_order/spei`),
  (PAY_ORDER_FISERV = exports.PAY_ORDER_FISERV = `${BASE_URL_V1}/pay_order/fiserv`),
  (PAYMENT_PROOF = exports.PAYMENT_PROOF = `${BASE_URL_V1}/client/:uuid/payment_proof`),
  (PAYMENT_EXPORT = exports.PAYMENT_EXPORT = `${BASE_URL_V1}/download/payment`),
  (PAYMENT_REFERENCE = exports.PAYMENT_REFERENCE = `${BASE_URL_V1}/payment/reference`),
  (PAY_ORDER_OYSTER = exports.PAY_ORDER_OYSTER = `${BASE_URL_V1}/pay_order/oyster`),
  // Credit Note
  (CREDIT_NOTE_BASE = exports.CREDIT_NOTE_BASE = `${BASE_URL_V1}/credit_note`),
  (CREDIT_NOTE_SINGLE = exports.CREDIT_NOTE_SINGLE = `${BASE_URL_V1}/credit_note/:uuid`),
  (CREDIT_NOTE_CANCEL_CFDI = exports.CREDIT_NOTE_CANCEL_CFDI = `${BASE_URL_V1}/credit_note/:uuid/cancel`),
  (CREDIT_NOTE_CANCE_NOTIFY = exports.CREDIT_NOTE_CANCE_NOTIFY = `${BASE_URL_V1}/credit_note/:uuid/cancel/notify`),
  (CREDIT_NOTE_NOTES = exports.CREDIT_NOTE_NOTES = `${BASE_URL_V1}/credit_note/:uuid/note`),
  (CREDIT_NOTE_EXPORT = exports.CREDIT_NOTE_EXPORT = `${BASE_URL_V1}/download/credit_note`),
  (CHECK_AS_PAID = exports.CHECK_AS_PAID = `${BASE_URL_V1}/payment/create-bulk-payments`),
  (IMPORT_CHECK_AS_PAID = exports.IMPORT_CHECK_AS_PAID = `${BASE_URL_V1}/payment/import-bulk-payments`),
  // Bulk Invoice Operations
  (BULK_INVOICE_BILL = exports.BULK_INVOICE_BILL = `${BASE_URL_V1}/import/invoice/bulk`),
  (BULK_INVOICE_BILL_NV = exports.BULK_INVOICE_BILL_NV = `${BASE_URL_V1}/import/invoice/nv-bulk`),
  (BULK_INVOICE_CANCEL = exports.BULK_INVOICE_CANCEL = `${BASE_URL_V1}/import/invoice/cancellation-bulk`),
  (BULK_NV_CANCEL = exports.BULK_NV_CANCEL = `${BASE_URL_V1}/import/invoice/nv-cancellation-bulk`),
  (BULK_BILLING_TEMPLATE = exports.BULK_BILLING_TEMPLATE = `${BASE_URL_V1}/templates/bulk-billing-template`),
  (BULK_CANCELLATION_TEMPLATE = exports.BULK_CANCELLATION_TEMPLATE = `${BASE_URL_V1}/templates/bulk-cancellation-template`),
  (BULK_IMPORT_DETAILS = exports.BULK_IMPORT_DETAILS = `${BASE_URL_V1}/import-cfdi/results/:workflowFileId`),
  // Currency
  (CURRENCY_RATES = exports.CURRENCY_RATES = `${BASE_URL_V1}/currency/rates`),
  // Short Urls
  (SHORT_URL = exports.SHORT_URL = `${BASE_URL}/uri`),
  // Notes
  (NOTES_BASE = exports.NOTES_BASE = `${BASE_URL_V1}/note/:uuid`),
  (SETTING_ATTRIBUTES = exports.SETTING_ATTRIBUTES = `${BASE_URL_V1}/settings/attributes`);
  // SOURCE PAYMENTS
  (SOURCE_PAYMENTS = exports.SOURCE_PAYMENTS = `${BASE_URL_V1}/source-payments`),
//APP VERSION
APP_VERSION = exports.APP_VERSION = `${BASE_URL_V1}/app/version`;

EARLY_PAYMENT = exports.EARLY_PAYMENT = `${BASE_URL_V1}/early_payment/catalog`;
EARLY_PAYMENT_BASE = exports.EARLY_PAYMENT_BASE = `${BASE_URL_V1}/early_payment`;
EARLY_PAYMENT_BYID = exports.EARLY_PAYMENT_BYID = `${BASE_URL_V1}/early_payment/:earlyPaymentId`;
EARLY_PAYMENT_CONTRACT = exports.EARLY_PAYMENT_CONTRACT = `${BASE_URL_V1}/early_payment/contracts/:earlyPaymentId`;

CSF_PARSER = exports.CSF_PARSER = `${BASE_URL_V2}/process-files/pdf-parser/csf`;
CUSTOMER_RELATION = exports.CUSTOMER_RELATION = `${BASE_URL_V1}/customer_relation/children/:clientId`;
CUSTOMER_RELATION_BASE = exports.CUSTOMER_RELATION_BASE = `${BASE_URL_V1}/customer_relation`;
CUSTOMER_RELATION_BYID = exports.CUSTOMER_RELATION_BYID = `${BASE_URL_V1}/customer_relation/:customerRelationId`;
BRANCH_TEMPLATE = exports.BRANCH_TEMPLATE = `${BASE_URL_V1}/download/branch_assignment`;
BRANCH_ASSIGNMENT_IMPORT = exports.BRANCH_ASSIGNMENT_IMPORT = `${BASE_URL_V1}/import/branch_assignment`;
COUNTRY_CODES = exports.COUNTRY_CODES = `${BASE_URL_V1}/country-codes`;
// Addenda
(CREATE_ADDENDA = exports.CREATE_ADDENDA = `${BASE_URL_V1}/educational-addendum`),
(ADDENDA_INFO = exports.ADDENDA_INFO = `${BASE_URL_V1}/educational-addendum/:uuid`);

const INTEREST_FORGIVENESS = exports.INTEREST_FORGIVENESS = `${BASE_URL_V2}/interests/forgiveness`;
const INTEREST_FORGIVENESS_BY_INVOICE = exports.INTEREST_FORGIVENESS_BY_INVOICE = `${BASE_URL_V2}/interests/forgiveness/:invoiceUuid`;
const INTEREST_FORGIVENESS_HISTORY = exports.INTEREST_FORGIVENESS_HISTORY = `${BASE_URL_V2}/interests/forgiveness/history/:invoiceUuid`;

//ACCOUNT STATEMENT SCHEDULE
const ACCOUNT_STATEMENT_SCHEDULE = exports.ACCOUNT_STATEMENT_SCHEDULE = `${BASE_URL_V1}/account-statement-schedule`;

// ASSIGNMENT RULES
const ASSIGNMENT_RULES = exports.ASSIGNMENT_RULES = `${BASE_URL_V1}/allocating-settlement-accounts-rules`;
const ASSIGNMENT_RULES_BY_ID = exports.ASSIGNMENT_RULES_BY_ID = `${BASE_URL_V1}/allocating-settlement-accounts-rules/:uuid`;
//PAYFAC PAYMENTS
const PAYFAC_PAYMENTS = exports.PAYFAC_PAYMENTS = `${BASE_URL_V1}/payfac/payments`;
const PAYFAC_RECURRING_PAYMENT = exports.PAYFAC_RECURRING_PAYMENT = `${BASE_URL_V1}/client/recurring_payment/payfac`;

//SYNCFY
const SYNCFY_SESSION_TOKEN = exports.SYNCFY_SESSION_TOKEN = `${BASE_URL_V1}/bank-reconciliation/session-token`;
const SYNCFY_JOB_STATUS = exports.SYNCFY_JOB_STATUS = `${BASE_URL_V1}/bank-reconciliation/jobs/:jobId/status`;
const SYNCFY_CREDENTIALS_SYNC = exports.SYNCFY_CREDENTIALS_SYNC = `${BASE_URL_V1}/bank-reconciliation/credentials/sync`;
const SYNCFY_ACCOUNTS = exports.SYNCFY_ACCOUNTS = `${BASE_URL_V1}/bank-reconciliation/accounts`;
const SYNCFY_SYNC_TRANSACTIONS = exports.SYNCFY_SYNC_TRANSACTIONS = `${BASE_URL_V1}/bank-reconciliation/accounts/:accountUuid/sync-transactions`;
const SYNCFY_DELETE_ACCOUNT = exports.SYNCFY_DELETE_ACCOUNT = `${BASE_URL_V1}/bank-reconciliation/accounts/:accountUuid`;
const SYNCFY_SITE_ORGANIZATIONS = exports.SYNCFY_SITE_ORGANIZATIONS = `${BASE_URL_V1}/bank-reconciliation/site-organizations`;
const PAYMENT_RECONCILIATION = exports.PAYMENT_RECONCILIATION = `${BASE_URL_V1}/payment-reconciliation/`;
const PAYMENT_RECONCILIATION_INVOICES = exports.PAYMENT_RECONCILIATION_INVOICES = `${BASE_URL_V1}/payment-reconciliation/invoices`;
const PAYMENT_RECONCILIATION_RECONCILE = exports.PAYMENT_RECONCILIATION_RECONCILE = `${BASE_URL_V1}/payment-reconciliation/reconcile`;
const BANK_IMPORT_PREVIEW = exports.BANK_IMPORT_PREVIEW = `${BASE_URL_V1}/bank-reconciliation/preview-statement`;
const BANK_IMPORT_STATEMENT = exports.BANK_IMPORT_STATEMENT = `${BASE_URL_V1}/bank-reconciliation/import-statement`;
const BANK_DELETE_TRANSACTION = exports.BANK_DELETE_TRANSACTION = `${BASE_URL_V1}/bank-reconciliation/transaction/:uuid`;
const BANK_DELETE_BATCH = exports.BANK_DELETE_BATCH = `${BASE_URL_V1}/bank-reconciliation/import-batch/:batchId`;
const PAYFAC_CHECKOUT_EVENTS = exports.PAYFAC_CHECKOUT_EVENTS = `${BASE_URL_V1}/payfac/checkout-events`;

// VOICE CALLS
const VOICE_CALLS = exports.VOICE_CALLS = `${BASE_URL_V1}/voice-agent`;
const VOICE_AGENT_STATS = exports.VOICE_AGENT_STATS = `${BASE_URL_V1}/voice-agent/stats`;
const VOICE_AGENT_CALLS = exports.VOICE_AGENT_CALLS = `${BASE_URL_V1}/voice-agent/calls`;
const VOICE_AGENT_CALLS_EXPORT = exports.VOICE_AGENT_CALLS_EXPORT = `${BASE_URL_V1}/voice-agent/calls/export`;
const VOICE_AGENT_TRANSCRIPT = exports.VOICE_AGENT_TRANSCRIPT = `${BASE_URL_V1}/voice-agent/:uuid/transcript`;
const VOICE_AGENT_CONFIG = exports.VOICE_AGENT_CONFIG = `${BASE_URL_V1}/voice-agent/config`;
// SPEI RECONCILIATION SANDBOX
const SPEI_RECONCILIATION_SANDBOX = exports.SPEI_RECONCILIATION_SANDBOX = `${BASE_URL}/customer/:customerUuid/sandbox-fund`;



// WEBPACK FOOTER //
// ./src/constants/endpoints.js